import { ButtonRoot } from './ButtonRoot';

export const Button = {
  Root: ButtonRoot,
};
